<template>
  <div class="pw-dropdown" :class="`is-${position}`">
    <div
      class="pw-dropdown__trigger"
      @click="handleClick"
      @mousedown="startTimer"
      @mouseup="cancelTimer"
      @contextmenu="prevent"
      ref="trigger"
    >
      <slot name="trigger">
        <Button color="transparent" :icon="icon" class="dropdown-dots" />
      </slot>
    </div>

    <transition :name="`pw-dropdown-${animation}`">
      <div class="pw-dropdown__menu" ref="pwDropdownMenu" v-show="!disabled && isActive">
        <div class="pw-dropdown__content">
          <slot />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Dropdown',
  props: {
    animation: {
      type: String,
      default: 'fadeIn',
    },
    icon: {
      type: String,
      default: 'dots-vertical',
    },
    position: {
      type: String,
      default: 'bottom-left',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    closeOnClick: {
      type: Boolean,
      default: true,
    },
    longPressDelay: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isActive: false,
      pressTimer: null,
    };
  },
  watch: {
    isActive(val) {
      if (val) {
        setTimeout(() => {
          this.$root.$el.addEventListener('click', this.clickOutside);
        }, 50);
      } else {
        this.$root.$el.removeEventListener('click', this.clickOutside);
      }
    },
  },
  beforeDestroy() {
    if (this.isActive) {
      this.$root.$el.removeEventListener('click', this.clickOutside);
    }
  },
  methods: {
    handleClick() {
      this.$emit('click'); // Emit custom event
    },
    prevent(event) {
      event.preventDefault();
      return false;
    },
    toggle() {
      if (this.disabled) {
        return;
      }

      if (!this.isActive) {
        this.$nextTick(() => {
          const value = !this.isActive;
          this.isActive = value;
          setTimeout(() => {
            this.isActive = value;
          });
        });
      } else {
        this.isActive = !this.isActive;
      }
    },
    startTimer(event) {
      if (event.type === 'click') {
        this.toggle();
        return;
      }

      if (this.longPressDelay === 0) {
        this.toggle();
      } else if (this.pressTimer === null && !this.isActive) {
        this.pressTimer = setTimeout(() => {
          // console.log('long press detected');
          this.toggle();
        }, this.longPressDelay);
      }
    },
    cancelTimer() {
      if (this.pressTimer !== null) {
        clearTimeout(this.pressTimer);
        this.pressTimer = null;
      }
    },
    clickOutside(event) {
      if (!this.closeOnClick) {
        console.log('clickOutside closeOnClick');
        return;
      }
      if (!this.isInWhiteList(event.target)) {
        this.isActive = false;
        this.cancelTimer();
      }
    },
    isInWhiteList(el) {
      if (el === this.$refs.pwDropdownMenu) {
        return true;
      }
      if (el === this.$refs.trigger) {
        return true;
      }
      if (this.$refs.pwDropdownMenu !== undefined) {
        const children = this.$refs.pwDropdownMenu.querySelectorAll('*');
        for (const child of children) {
          if (el === child) {
            return true;
          }
        }
      }
      if (this.$refs.trigger !== undefined) {
        const children = this.$refs.trigger.querySelectorAll('*');
        for (const child of children) {
          if (el === child) {
            return true;
          }
        }
      }
      return false;
    },
  },
};
</script>

<style lang="scss">
.pw-dropdown-fadeIn-enter-active {
  transition: all 0.2s ease;
}
.pw-dropdown-fadeIn-leave-active {
  transition: all 0.1s cubic-bezier(1, 0.5, 0.8, 1);
}
.pw-dropdown-fadeIn-enter, .pw-dropdown-fadeIn-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.pw-dropdown {
  display: inline-block;
  position: relative;
  &__menu {
    min-width: 12rem;
    border-radius: 3px;
    background-color: #fff;
    border: 1px solid #d8e3eb;
    box-shadow: 0 3px 6px 0 #d8e3eb;
    padding: 4px;
    position: absolute;
    z-index: 10000000;
  }
  &.is-top-left {
    .pw-dropdown__menu {
      bottom: 100%;
      left: 0;
    }
  }
  &.is-top-right {
    .pw-dropdown__menu {
      bottom: 100%;
      right: 0;
    }
  }
  &.is-bottom-right {
    .pw-dropdown__menu {
      top: 100%;
      right: 0;
    }
  }
  &.is-bottom-left {
    .pw-dropdown__menu {
      top: 100%;
      left: 0;
    }
  }
  .dropdown-dots {
    padding-top: 0;
    padding-right: 5px;
    padding-bottom: 5px;
    .mdi {
      font-size: 18px;
    }
  }
}
</style>
